var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.liveRanking)?_c('ActiveRanking',{attrs:{"rankData":_vm.rankData}}):_c('InactiveRanking',{attrs:{"rankData":_vm.rankData}})
}
var staticRenderFns = []

export { render, staticRenderFns }